/* ── Apartament Na Skarpie — Main JS ── */

document.addEventListener( 'DOMContentLoaded', () => {

	// ── 1. Mobile Drawer ──────────────────────────────────────────────────── //

	const hamburgerBtn = document.getElementById( 'hamburger-btn' );
	const drawer       = document.getElementById( 'mobile-drawer' );
	const backdrop     = document.getElementById( 'mobile-drawer-backdrop' );
	const closeBtn     = document.getElementById( 'mobile-drawer-close' );

	let isDrawerOpen = false;

	function openDrawer() {
		if ( ! drawer ) return;
		isDrawerOpen = true;
		drawer.classList.add( 'is-open' );
		backdrop?.classList.add( 'is-visible' );
		hamburgerBtn?.classList.add( 'is-open' );
		hamburgerBtn?.setAttribute( 'aria-expanded', 'true' );
		document.body.style.overflow = 'hidden';
		const firstFocusable = drawer.querySelector( 'a, button' );
		firstFocusable?.focus();
	}

	function closeDrawer() {
		if ( ! drawer ) return;
		isDrawerOpen = false;
		drawer.classList.remove( 'is-open' );
		backdrop?.classList.remove( 'is-visible' );
		hamburgerBtn?.classList.remove( 'is-open' );
		hamburgerBtn?.setAttribute( 'aria-expanded', 'false' );
		document.body.style.overflow = '';
		hamburgerBtn?.focus();
	}

	hamburgerBtn?.addEventListener( 'click', () => {
		isDrawerOpen ? closeDrawer() : openDrawer();
	} );

	backdrop?.addEventListener( 'click', closeDrawer );
	closeBtn?.addEventListener( 'click', closeDrawer );

	document.addEventListener( 'keydown', ( e ) => {
		if ( e.key === 'Escape' && isDrawerOpen ) closeDrawer();
	} );

	drawer?.querySelectorAll( '.mobile-nav-link, .btn-primary' ).forEach( ( link ) => {
		link.addEventListener( 'click', closeDrawer );
	} );


	// ── 2. Sticky Header Scroll Behavior ─────────────────────────────────── //

	const header = document.querySelector( '.site-header' );
	let lastScrollY = 0;

	if ( header ) {
		window.addEventListener( 'scroll', () => {
			const currentScrollY = window.scrollY;
			header.classList.toggle( 'is-scrolled', currentScrollY > 60 );
			if ( currentScrollY > 120 ) {
				header.classList.toggle( 'is-hidden', currentScrollY > lastScrollY );
			} else {
				header.classList.remove( 'is-hidden' );
			}
			lastScrollY = currentScrollY;
		}, { passive: true } );
	}


	// ── 3. Scroll-Activated Animations (Intersection Observer) ───────────── //

	const animatedElements = document.querySelectorAll( '[data-animate]' );

	if ( animatedElements.length > 0 && 'IntersectionObserver' in window ) {
		const observer = new IntersectionObserver(
			( entries ) => {
				entries.forEach( ( entry ) => {
					if ( entry.isIntersecting ) {
						entry.target.classList.add( 'is-visible' );
						observer.unobserve( entry.target );
					}
				} );
			},
			{ threshold: 0.12, rootMargin: '0px 0px -40px 0px' }
		);
		animatedElements.forEach( ( el ) => observer.observe( el ) );
	} else {
		animatedElements.forEach( ( el ) => el.classList.add( 'is-visible' ) );
	}


	// ── 4. Attractions Tab Switcher ──────────────────────────────────────── //

	const tabBtns   = document.querySelectorAll( '.tab-btn' );
	const tabPanels = document.querySelectorAll( '.tab-panel' );

	if ( tabBtns.length > 0 ) {
		tabBtns.forEach( ( btn ) => {
			btn.addEventListener( 'click', () => {
				const targetId = btn.dataset.target;
				tabBtns.forEach( ( b ) => {
					const isActive = b === btn;
					b.classList.toggle( 'tab-btn--active', isActive );
					b.setAttribute( 'aria-selected', isActive ? 'true' : 'false' );
				} );
				tabPanels.forEach( ( panel ) => {
					panel.classList.toggle( 'tab-panel--hidden', panel.id !== targetId );
				} );
				const visiblePanel = document.getElementById( targetId );
				if ( visiblePanel ) {
					visiblePanel.querySelectorAll( '[data-animate]:not(.is-visible)' ).forEach( ( el ) => {
						setTimeout( () => el.classList.add( 'is-visible' ), 50 );
					} );
				}
			} );
		} );

		tabBtns.forEach( ( btn, index ) => {
			btn.addEventListener( 'keydown', ( e ) => {
				let newIndex = -1;
				if ( e.key === 'ArrowRight' || e.key === 'ArrowDown' ) {
					newIndex = ( index + 1 ) % tabBtns.length;
				} else if ( e.key === 'ArrowLeft' || e.key === 'ArrowUp' ) {
					newIndex = ( index - 1 + tabBtns.length ) % tabBtns.length;
				}
				if ( newIndex >= 0 ) {
					e.preventDefault();
					tabBtns[ newIndex ].click();
					tabBtns[ newIndex ].focus();
				}
			} );
		} );
	}


	// ── 5. Smooth Scroll for Anchor Links ───────────────────────────────── //

	document.querySelectorAll( 'a[href^="#"]' ).forEach( ( anchor ) => {
		anchor.addEventListener( 'click', function ( e ) {
			const targetSelector = this.getAttribute( 'href' );
			if ( targetSelector === '#' ) return;
			const targetEl = document.querySelector( targetSelector );
			if ( ! targetEl ) return;
			e.preventDefault();
			const headerHeight = header ? header.offsetHeight : 72;
			const targetTop = targetEl.getBoundingClientRect().top + window.scrollY - headerHeight;
			window.scrollTo( { top: targetTop, behavior: 'smooth' } );
			if ( isDrawerOpen ) closeDrawer();
			history.pushState( null, '', targetSelector );
		} );
	} );


	// ── 6. Scroll Spy — Active Nav Link ─────────────────────────────────── //

	const sections = document.querySelectorAll( 'section[id]' );
	const navLinks = document.querySelectorAll( '.primary-menu a[href^="#"]' );

	if ( sections.length > 0 && navLinks.length > 0 && 'IntersectionObserver' in window ) {
		const spyObserver = new IntersectionObserver(
			( entries ) => {
				entries.forEach( ( entry ) => {
					if ( entry.isIntersecting ) {
						const id = entry.target.id;
						navLinks.forEach( ( link ) => {
							link.classList.toggle( 'is-active', link.getAttribute( 'href' ) === `#${ id }` );
						} );
					}
				} );
			},
			{ threshold: 0.4 }
		);
		sections.forEach( ( section ) => spyObserver.observe( section ) );
	}


	// ── 7. Mobile Datepick Width Fix ─────────────────────────────────────── //
	// MotoPress JS injects inline width on .datepick for its two-month layout.
	// On mobile we collapse to one month; strip the inline width so CSS takes over.
	{
		const mq = window.matchMedia( '(max-width: 767px)' );
		new MutationObserver( () => {
			if ( ! mq.matches ) return;
			document.querySelectorAll( '.datepick' ).forEach( ( dp ) => {
				if ( dp.style.width ) dp.style.removeProperty( 'width' );
			} );
		} ).observe( document.body, { subtree: true, attributes: true, attributeFilter: [ 'style' ] } );
	}


	// ── 8. Gallery Lightbox ──────────────────────────────────────────────── //

	const galleryItems = document.querySelectorAll( '[data-lightbox]' );

	if ( galleryItems.length > 0 ) {
		const lb = document.createElement( 'div' );
		lb.id = 'gallery-lightbox';
		lb.className = 'lightbox';
		lb.setAttribute( 'role', 'dialog' );
		lb.setAttribute( 'aria-modal', 'true' );
		lb.setAttribute( 'aria-label', 'Podgląd zdjęcia' );
		lb.setAttribute( 'hidden', '' );
		lb.innerHTML = `
			<div class="lightbox__backdrop"></div>
			<button class="lightbox__close" aria-label="Zamknij podgląd" type="button">
				<svg viewBox="0 0 24 24" width="24" height="24" fill="none" stroke="currentColor" stroke-width="2.5" aria-hidden="true"><line x1="18" y1="6" x2="6" y2="18"/><line x1="6" y1="6" x2="18" y2="18"/></svg>
			</button>
			<button class="lightbox__prev" aria-label="Poprzednie zdjęcie" type="button">
				<svg viewBox="0 0 24 24" width="24" height="24" fill="none" stroke="currentColor" stroke-width="2.5" aria-hidden="true"><polyline points="15 18 9 12 15 6"/></svg>
			</button>
			<button class="lightbox__next" aria-label="Następne zdjęcie" type="button">
				<svg viewBox="0 0 24 24" width="24" height="24" fill="none" stroke="currentColor" stroke-width="2.5" aria-hidden="true"><polyline points="9 18 15 12 9 6"/></svg>
			</button>
			<figure class="lightbox__figure">
				<img class="lightbox__img" src="" alt="" width="1" height="1">
				<figcaption class="lightbox__caption visually-hidden"></figcaption>
			</figure>`;
		document.body.appendChild( lb );

		const lbImg       = lb.querySelector( '.lightbox__img' );
		const lbCaption   = lb.querySelector( '.lightbox__caption' );
		const lbCloseBtn  = lb.querySelector( '.lightbox__close' );
		const lbPrevBtn   = lb.querySelector( '.lightbox__prev' );
		const lbNextBtn   = lb.querySelector( '.lightbox__next' );
		const lbBackdrop  = lb.querySelector( '.lightbox__backdrop' );
		const lbItems     = Array.from( galleryItems );
		let lbIndex       = 0;
		let lbPrevFocus   = null;

		function lbUpdateImage( index ) {
			const item            = lbItems[ index ];
			lbImg.src             = item.dataset.full;
			lbImg.alt             = item.dataset.alt || '';
			lbCaption.textContent = item.dataset.alt || '';
			lbPrevBtn.hidden      = lbItems.length <= 1;
			lbNextBtn.hidden      = lbItems.length <= 1;
		}

		function lbOpen( index ) {
			lbIndex     = index;
			lbPrevFocus = document.activeElement;
			lbUpdateImage( index );
			lb.removeAttribute( 'hidden' );
			lb.classList.add( 'is-open' );
			document.body.style.overflow = 'hidden';
			lbCloseBtn.focus();
		}

		function lbClose() {
			lb.classList.remove( 'is-open' );
			lb.setAttribute( 'hidden', '' );
			document.body.style.overflow = '';
			lbPrevFocus?.focus();
		}

		function lbShow( index ) {
			lbIndex = ( index + lbItems.length ) % lbItems.length;
			lbUpdateImage( lbIndex );
		}

		lbItems.forEach( ( item, i ) => {
			item.addEventListener( 'click', () => lbOpen( i ) );
			item.addEventListener( 'keydown', ( e ) => {
				if ( e.key === 'Enter' || e.key === ' ' ) { e.preventDefault(); lbOpen( i ); }
			} );
		} );

		lbCloseBtn.addEventListener( 'click', lbClose );
		lbBackdrop.addEventListener( 'click', lbClose );
		lbPrevBtn.addEventListener( 'click', () => lbShow( lbIndex - 1 ) );
		lbNextBtn.addEventListener( 'click', () => lbShow( lbIndex + 1 ) );

		document.addEventListener( 'keydown', ( e ) => {
			if ( ! lb.classList.contains( 'is-open' ) ) return;
			if ( e.key === 'Escape' )     lbClose();
			if ( e.key === 'ArrowLeft' )  lbShow( lbIndex - 1 );
			if ( e.key === 'ArrowRight' ) lbShow( lbIndex + 1 );
		} );

		lb.addEventListener( 'keydown', ( e ) => {
			if ( e.key !== 'Tab' ) return;
			const focusable = Array.from( lb.querySelectorAll( 'button:not([hidden])' ) );
			const first = focusable[ 0 ];
			const last  = focusable[ focusable.length - 1 ];
			if ( e.shiftKey ) {
				if ( document.activeElement === first ) { e.preventDefault(); last.focus(); }
			} else {
				if ( document.activeElement === last )  { e.preventDefault(); first.focus(); }
			}
		} );
	}

} );
